import { render, staticRenderFns } from "./DayTemplateRemovalCard.vue?vue&type=template&id=3e58c2a8&"
import script from "./DayTemplateRemovalCard.vue?vue&type=script&lang=js&"
export * from "./DayTemplateRemovalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports